import React from "react";
import CustomTable from "../customTable";
import { ResultsPerListAndCampaignsColumns } from "./columns/ResultsPerListAndCampaignsColumns";
import Comments from "../comments";

// Define columns based on ResultsPerListAndCampaignsColumns
const ResultsPerProductColumns = [
  { header: "Product", accessor: "product" },
  { header: "Product Description", accessor: "product_description" },
  { header: "Category", accessor: "category" },
  ...ResultsPerListAndCampaignsColumns.slice(7),
];

const ResultsPerProduct = ({ processedData, loading }) => {

  return (
    <div className="d-flex flex-column gap-2">
      <CustomTable
        columns={ResultsPerProductColumns}
        data={processedData?.results_per_product?.data || []}
        totalAggregatedData={processedData?.results_per_product?.totals || {}}
        loading={loading}
        storageKey={"resultsperproduct"}
      />
      <Comments tab_name="Results per product" />
    </div>
  );
};

export default ResultsPerProduct;
